/**
 * What Settings → Screens offers (docs/NEW-UI/07 D-04): for each step of the task, in order, the look of the widget its
 * screens show, when the widget has more than one. Screens of the same step showing the same widget are one choice
 * (results and selected: the trains found). Read from the pack's screens as the spec describes them; no screen named.
 */
import { STEP_DONE, type KioskPack } from '../../packs/contract';
import { variantsOf, type WidgetDefinition } from '../../widgets/contract';

export interface ScreenChoice {
  /** The screens the choice applies to. */
  screens: string[];
  widget: string;
  /** What the row is called: the step's label key, else the widget's name key, else the screen itself. */
  label: string;
  /** The looks offered, the standard one first. */
  variants: { id: string; label: string }[];
}

/** The i18n key of the row of a screen that ends the task. */
export const END_LABEL = 'settings.screens.end';

export function screenChoices(pack: KioskPack, widgets: ReadonlyMap<string, WidgetDefinition<never>>, hasKey: (key: string) => boolean): ScreenChoice[] {
  const byRow = new Map<string, ScreenChoice>();
  for (const [screen, def] of Object.entries(pack.screens)) {
    for (const widget of def.widgets ?? []) {
      const definition = widgets.get(widget);
      if (!definition || (definition.variants?.length ?? 0) === 0) continue;
      const row = `${def.step ?? screen}/${widget}`;
      const known = byRow.get(row);
      if (known) {
        known.screens.push(screen);
        continue;
      }
      const step = pack.steps.find((s) => s.id === def.step);
      const named = `widget.name.${widget}`;
      const label = step ? step.label : def.step === STEP_DONE ? END_LABEL : hasKey(named) ? named : screen;
      byRow.set(row, { screens: [screen], widget, label, variants: variantsOf(definition).map((v) => ({ id: v.id, label: v.label })) });
    }
  }
  return [...byRow.values()];
}
